import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery, textOverflowHidden, Transition } from '../../../../styles';

const useStyles = createUseStyles(
  ({ spacing, breakpoints }: ITheme) => ({
    root: {
      padding: 16,
    },
    header: {
      display: 'flex',
      alignItems: 'start',
      gap: spacing.small,
    },
    footer: {
      display: 'flex',
      alignItems: 'end',
      gap: spacing.small,
    },
    areaLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing.small,
    },
    areaCenter: {
      flex: 1,
      width: 0,

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    areaRight: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing.small,
    },
    content: {
      padding: spacing.medium,
    },
    actions: {
      '& button': {
        border: 'none',
        outline: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',

        '& svg > path': {
          fill: 'var(--x-icon-color-2)',
        },

        '&:hover, &:focus': {
          '& svg > path': {
            fill: 'var(--x-icon-color-1)',
          },
          '&.delete': {
            '& svg > path': {
              fill: 'var(--x-status-error)',
            },
          },
        },

        '&[disabled]': {
          cursor: 'not-allowed',

          '& svg > path': {
            fill: 'var(--x-icon-color-2) !important',
          },
        },
      },
    },
    page: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 123,
      height: 174,

      margin: '0 auto',

      overflow: 'hidden',

      borderRadius: 8,
      backgroundColor: 'var(--x-bg-2)',

      transition: `all ease-in-out ${Transition.Fast}`,

      boxShadow: '0 4px 2px -1px var(--x-shadow-1)',

      '&.landscape': {
        width: 232,
        height: 165,
      },

      '&.margin-small': {
        padding: spacing.small,
      },

      '&.margin-large': {
        padding: spacing.large,
      },

      [mediaQuery(breakpoints.laptop)]: {
        width: 72,
        height: 102,
        borderRadius: 4,
        backgroundColor: 'var(--x-bg-2)',

        '&.landscape': {
          width: 135,
          height: 96,
        },
      },
    },
    corner: {
      display: 'block',
      width: 39,
      height: 39,
      position: 'absolute',
      right: -7,
      top: -5,

      [mediaQuery(breakpoints.laptop)]: {
        width: 19,
        height: 19,
        right: -2,
        top: -2,

        '& path:first-child': {
          fill: 'var(--x-bg-1)',
        },
      },
    },
    thumbnail: {
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
    },
    thumbnailText: {
      padding: 8,
      textAlign: 'center',
      color: 'var(--x-text-color-2)',
      fontSize: 12,
    },
    fileNameSizeContainer: {
      width: '100%',
      textAlign: 'center',
    },
    fileName: {
      fontSize: 14,
      fontWeight: FontWeight.Bold,

      ...textOverflowHidden,
    },
    fileSize: {
      fontSize: 14,
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-text-color-2)',

      ...textOverflowHidden,
    },
  }),
  { name: 'file-card-list-item' },
);

export default useStyles;
